export default "__VITE_ASSET__77dfbe07__"